import {
  ActivityFilterKey
} from '@gripp/shared-logic';
import {
  ActivityList,
  SlideAction,
  SlideLayout,
  useSlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import { useWindowDimensions } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import { ActivityFilters } from '../../activity/components/activityFilters';
import { isFromActivitiesOrAssetPage } from '../assetUtils';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetDetail = () => {
  const { assetId } = useParams();
  const navigate = useNavigate();

  if (!assetId) {
    return null;
  }

  const leftColumn = {
    title: 'assets.menu.title',
    mainComponent: <AssetCard assetId={assetId} pageSize={3} />,
    headerComponent: <AssetFilters assetId={assetId} />,
    showBackButton: false,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'activity.header.title',
    mainComponent: <RightColumn assetId={assetId} />,
    headerComponent: <ActivityFilters />,
    showBackButton: true,
    disableScroll: true,
    onBackButtonPress: () => {
      try {
        // Prefer navigating back when the previous entry looks like an
        // activities or assets page. `document.referrer` works for full-page
        // navigations; for SPA navigations we still fall back to checking
        // history index.
        const cameFromActivityOrAsset = isFromActivitiesOrAssetPage(document);

        if (cameFromActivityOrAsset && history?.state?.idx > 0) {
          navigate(-1);
          return;
        } else {
          navigate(`/assets/${assetId}`);
        }
      } catch (e) {
        navigate(`/assets/${assetId}`);
      }
    },
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const RightColumn = ({ assetId }: { assetId: string }) => {
  const { onSlideChange } = useSlideLayout();
  const windowDimensions = useWindowDimensions();
  const windowHeight = (windowDimensions?.height ?? 0);
  const maxHeight = windowHeight - 105;
  const navigate = useNavigate();
  
  const onIssueSelected = async (issueId: string) => {
    await onSlideChange(SlideAction.NEXT);

    navigate(`/assets/${assetId}/activity/${issueId}`);
  };

  return (
    <ActivityList
      filterKey={ActivityFilterKey.Activity}
      listMaxHeight={maxHeight}
      onIssueSelected={onIssueSelected}
      assetId={assetId}
      showAssetName={false}
      pageSize={50}
    />
  );
};